<div class="cm-panel" role="group" [attr.aria-label]="'modules.form.columnMappings.title' | translate">
  <div class="cm-panel__title">{{ 'modules.form.columnMappings.title' | translate }}</div>
  <div class="cm-panel__rows">
    @for (col of sheet().spalten; track trackColumn($index, col)) {
      <div class="cm-row">
        <code class="cm-col">{{ col }}</code>
        <span class="cm-arrow" aria-hidden="true">{{ 'modules.form.columnMappings.arrow' | translate }}</span>
        <select
          class="cm-select"
          [class.cm-select--empty]="selectValue(col) === ''"
          [disabled]="readOnly()"
          [attr.aria-label]="'modules.form.columnMappings.selectAria' | translate: { column: col }"
          (change)="onSelectChange(col, $event)"
        >
          <option value="" [selected]="selectValue(col) === ''">
            {{ 'modules.form.columnMappings.unassigned' | translate }}
          </option>
          @for (name of parameterNames(); track name) {
            <option [value]="name" [selected]="selectValue(col) === name">
              {{ name }}{{ isRequired(name) ? ' *' : '' }}
            </option>
          }
        </select>
      </div>
    }
  </div>

  @if (missingRequired().length > 0) {
    <p class="cm-warning" role="alert">
      <span class="cm-warning__icon" aria-hidden="true">✕</span>
      {{ 'modules.form.columnMappings.missingRequiredPrefix' | translate }} {{ missingRequired().join(', ') }}
    </p>
  }

  <p class="cm-hint">{{ 'modules.form.columnMappings.hint' | translate }}</p>
</div>
